var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BootstrapModal',_vm._g({staticClass:"ProductSelector",on:{"save":_vm.addProducts},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]},proxy:true}])},_vm.$listeners),[_c('ProductFinder',{model:{value:(_vm.products),callback:function ($$v) {_vm.products=$$v},expression:"products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }